import React, { SelectHTMLAttributes, useState } from "react";
import { iModuloData, iOpt, iPermissoesData, } from "../../Types/Types";
import { Select } from "antd";
import api from "../../helpers/axios";

type iProps = SelectHTMLAttributes<HTMLSelectElement> & {
    placeHolder?: string;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    value: string[] | null;
    setValue: Function;
    execOnChange?: Function
}

export default function SelectModulos({ value, label, disabled, setValue,execOnChange, ...rest }: iProps) {
    const [options, setOptions] = useState<iOpt[]>([]);
    React.useEffect(() => {
        api.get('/modulos').then((response) => {
            const tempOpt = [] as iOpt[];
            (response.data as iModuloData[]).map(item => {
                tempOpt.push({
                    value: item._id.toString(),
                    label: item.nome.toString()
                })
            })
            setOptions(tempOpt);
        });

    }, []);
    const handleChange = (value: string[]) => {
        console.log(`Selected: ${value}`);
        if(execOnChange){
            execOnChange(value);
        }
        setValue(value);
    };
    return (
        <div>
            {label ? (
                <label
                    className="block mb-2 text-sm text-navy-700 font-bold"
                >
                    {label}
                </label>
            ) : (
                ''
            )}
            <Select
                mode="multiple"
                allowClear
                size="large"
                placeholder="Modulos"
                // defaultValue={[]}
                onChange={handleChange}
                value={value}
                style={{ width: "100%" }}
                options={options}
            />
        </div>
    );
}
